import { jsxs, jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import Table from '../Table/Table.js';
import Formatter from '../Formatter/Formatter.js';
import Button from '../Button/Button.js';
import { FormatterType } from '../Formatter/formatterUtils.js';

const renderMessageRow = (operazione, message, idx, onRimuovi) => (jsxs("tr", { children: [jsxs("td", { className: "snackbar__timeStamp", children: [jsx(Formatter, { tipo: FormatterType.date, valore: operazione.timeStamp }), "-", jsx(Formatter, { tipo: FormatterType.hour, valore: operazione.timeStamp })] }), jsx("td", { children: message }), jsxs("td", { className: "snackbar__actions", children: [jsx(Button, { onClick: () => onRimuovi(idx), text: true, children: "OK" }), operazione.actions] })] }, idx));
class TabellaOperazioneSincrona extends Component {
    constructor(props) {
        super(props);
        this.rimuoviErrore = (indexMessage) => {
            const { rimuoviOperazione } = this.props;
            const { operazione } = this.state;
            const op = operazione;
            op.message = op.message.filter((x, i) => i !== indexMessage);
            if (op.message.length > 0) {
                this.setState({
                    operazione: op,
                });
            }
            else {
                rimuoviOperazione(operazione.index);
            }
        };
        this.state = {
            operazione: props.operazione,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { operazione } = this.props;
        if (nextProps.operazione.index !== operazione.index) {
            this.setState({
                operazione: nextProps.operazione,
            });
        }
    }
    render() {
        const { rimuoviOperazione, } = this.props;
        const { operazione, } = this.state;
        return (jsxs(Table, { className: "snackbar__tabellaErrori", children: [jsx(Table.Head, { children: jsxs("tr", { children: [jsx("th", { style: { width: '20%' }, children: "Data e ora" }), jsx("th", { style: { width: '70%' }, children: "Errore" }), jsx("th", { style: { width: '10%' }, children: "Azioni" })] }) }), jsx(Table.Body, { children: Array.isArray(operazione.message)
                        ? operazione.message.map((x, i) => renderMessageRow(operazione, x, i, this.rimuoviErrore))
                        : renderMessageRow(operazione, operazione.content
                            || operazione.message, operazione.index, rimuoviOperazione) })] }));
    }
}
TabellaOperazioneSincrona.defaultProps = {
    operazione: null,
    rimuoviOperazione: null,
};

export { TabellaOperazioneSincrona as default };
